//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, email, phone } from '~/utils/validation.js';
import { cleanObj } from '~/utils';

export default {
  data() {
    return {
      isSent: false,
      dataForm: {
        name: '',
        nickName: '',
        phoneNumber: '',
        email: '',
        subject: '',
        content: '',
      },
      rules: {
        name: [required],
        phoneNumber: [required, phone],
        email: [required, email],
        subject: [required],
        content: [required],
      },
    };
  },
  methods: {
    onClickSend() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) {
          return false;
        }

        this.$api('sendMail', cleanObj(this.dataForm, true))
          .then(data => {
            this.$message.success('已送出，感謝您的聯繫!');
            this.isSent = true;
          })
          .catch(() => {
            this.$message.error('送出失敗!');
          });
      });
    },
  },
};
